import * as React from 'react'

import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import RadioGroup from 'modules/core/components/Inputs/RadioGroup'
import LabeledInput from 'modules/core/components/LabeledInput'
import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { GROUPING_DATE_PARTS } from 'modules/reports/lib/Constants'

interface Props {
  fieldType: FieldType
}

const GroupingOptions = ({ fieldType }: Props) => {
  const form = fieldType.form
  const field = form.get('group')
  const value = field.value
  // TODO: This is strange, why does this mutate the form?
  React.useEffect(() => {
    if (isEmpty(value)) {
      form.setValues({
        group: GROUPING_DATE_PARTS.month,
      })
    }
  }, [form, value])

  return (
    <LabeledInput
      focused={false}
      label={i18n.t('custom_reports.ability_labels.group_by')}
      value={field.value || ''}
      error={field.errors as any}
    >
      <RadioGroup
        invisibleRadio
        name="dayType"
        theme="toggle"
        field={field}
        options={[
          {
            value: GROUPING_DATE_PARTS.day,
            label: i18n.t('custom_reports.grouping_options.day'),
          },
          {
            value: GROUPING_DATE_PARTS.month,
            label: i18n.t('custom_reports.grouping_options.month'),
          },
          {
            value: GROUPING_DATE_PARTS.year,
            label: i18n.t('custom_reports.grouping_options.year'),
          },
        ]}
      />
    </LabeledInput>
  )
}

export default observer(GroupingOptions)
